import script from "./ManageBrand.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBrand.vue?vue&type=script&setup=true&lang=js"

import "./ManageBrand.vue?vue&type=style&index=0&id=ed17ecda&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebasedevdemo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed17ecda"]])

export default __exports__